import { Element, State } from 'shared/core';
import { Injectable } from 'injection-js';
import { Flash } from 'shared/lib';
import { Actions } from 'shared/state';

@Injectable()
export class PersonalisationsElement extends Element {
  constructor(private state: State) {
    super();
  }

  public init() {
    $('body').on('click', '.openOrderItemPersonalisationModal', e => {
      e.preventDefault();
      let id = $(e.target).closest('.openOrderItemPersonalisationModal').data('personalisationsId');
      this.openEditPersonalisationModal(id);
    });

    $('body').on('click', '.add_personalisation', e => {
      e.preventDefault();

      let personalisationRow = $(e.target).closest('.personalisation');

      if (personalisationRow.hasClass('selected-personalisation')) {
        this.removePersonalisation(personalisationRow);
      } else {
        this.addPersonalisation(personalisationRow);
      }
    });

    $('body').on('click', '.openPersonalisationConfirmationModal', e => {
      e.preventDefault();

      let id = $(e.target).closest('.openPersonalisationConfirmationModal').data('personalisationsId');

      let validText = [] ;
      let selectedPersonalisations: { title: string, content: string }[] = [];

      $(`#${id} .personalisation`).each((i, el) => {
        let personalisationRow = $(el);
        let personalisationTitle = personalisationRow.data('title');
        let personalisationTextInput =  personalisationRow.find('.personalisation_input');
        let personalisationInput = personalisationRow.find('.personalisationSelectedValue');
        validText.push(this.validatePersonalisationText(personalisationTextInput));

        if (this.validatePersonalisationText(personalisationTextInput) && personalisationInput.val() == '1') {
          selectedPersonalisations.push({
            title: personalisationTitle,
            content: personalisationTextInput.val() as string
          });
        }
      });

      if (validText.includes(false)) {
        Flash.genericAlert('Personalisations can only contain standard characters A-Z and 0-9');
      } else {
        this.openConfirmationModal(selectedPersonalisations);
      }
    });
  }

  private removePersonalisation(personalisationRow: JQuery): void {
    let personalisationIcon = personalisationRow.find('i.fa.fa-solid.fa-minus-square');
    let personalisationInput = personalisationRow.find('.personalisationSelectedValue');
    let personalisationBtn = personalisationRow.find('.personalisation-td-btn > a');

    personalisationRow.removeClass('selected-personalisation');
    personalisationRow.addClass('without-selected');
    personalisationIcon.removeClass('fa fa-solid fa-minus-square');
    personalisationIcon.addClass('fa fa-solid fa-plus-square');
    personalisationInput.val('0');
    personalisationBtn.text('Add');
  }

  private addPersonalisation(personalisationRow: JQuery): void {
    let personalisationIcon = personalisationRow.find('i.fa.fa-solid.fa-plus-square');
    let personalisationTextInput = personalisationRow.find('.personalisation_input');
    let personalisationInput = personalisationRow.find('.personalisationSelectedValue');
    let personalisationBtn = personalisationRow.find('.personalisation-td-btn > a');

    personalisationRow.removeClass('without-selected');
    personalisationTextInput.prop('disabled', false);
    personalisationRow.addClass('selected-personalisation');
    personalisationInput.val('1');
    personalisationIcon.removeClass('fa fa-solid fa-plus-square');
    personalisationIcon.addClass('fa fa-solid fa-minus-square');
    personalisationBtn.text('Remove');
  }

  private validatePersonalisationText(personalisationTextInput: JQuery): boolean {
    if (personalisationTextInput.val() == '') {
      return true;
    }
    const regexp = new RegExp(/^[\x00-\x7F\xA0-\xFF]*$/);
    return regexp.test(personalisationTextInput.val() as string);
  }

  private openConfirmationModal(selectedPersonalisations: { title: string, content: string }[]): void {
    this.state.dispatch({ name: Actions.OPEN_STATIC_MODAL, payload: 'confirmPersonalisationModal' });

    if (selectedPersonalisations.length === 0) {
      $('#confirmMessage').html('You have not selected any personalisations, are you sure you want to continue?');
      $('#newContent').html('');
    } else {
      $('#confirmMessage').html('Are you sure you\'d like the personalisation details to be:');
      let content: string[] = [];

      selectedPersonalisations.forEach(personalisation => {
        content.push(`${personalisation.title}: ${personalisation.content}`);
      });

      $('#newContent').html(content.join('<br />'));

      $('.confirmPersonalisation').on('click', () => {
        this.state.dispatch({ name: Actions.CLOSE_MODAL, payload: 'confirmPersonalisationModal' });
      });
    }
  }

  private renderPersonalisationRow(id: string): void {
    $(`#${id} .personalisation`).each((i, el) => {
      let personalisationRow = $(el);
      let personalisationInput = personalisationRow.find('.personalisationSelectedValue');

      if (personalisationInput.val() == 'true') {
        this.addPersonalisation(personalisationRow);
      }
    });
  }

  private openEditPersonalisationModal(id: string): void {
    // Find basket identity
    // Open new modal by HTML
    let modalHtml = $(`#editOrderItemPersonalisation_${id}`);
    this.state.dispatch({ name: Actions.OPEN_NEW_MODAL, payload: { modal: modalHtml } });

    this.renderPersonalisationRow(id);
  }
}
